import { AppLayoutTitle } from "@app/components/sparkle/AppLayoutTitle";
import { Button, XMarkIcon } from "@dust-tt/sparkle";
import type React from "react";

interface InteractiveContentHeaderProps {
  children?: React.ReactNode;
  onClose?: () => void;
}

export function InteractiveContentHeader({
  children,
  onClose,
}: InteractiveContentHeaderProps) {
  return (
    <AppLayoutTitle className="bg-gray-50 @container dark:bg-gray-900">
      <div className="flex h-full items-center">
        {children}
        {onClose && (
          <Button
            variant="ghost"
            onClick={onClose}
            icon={XMarkIcon}
            className="text-element-600 hover:text-element-900 ml-auto"
          />
        )}
      </div>
    </AppLayoutTitle>
  );
}
